// Web Storage access that tolerates SSR, a null storage object (some in-app
// browsers expose `window.localStorage === null`), and SecurityError thrown
// while reading the accessor. Callers fall back as if the key were missing.
export const getSessionStorageItem = (key: string): string | null => {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
};

export const setSessionStorageItem = (key: string, value: string): void => {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage?.setItem(key, value);
  } catch {
    // Silently fail if storage is not available
  }
};

export const removeSessionStorageItem = (key: string): void => {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage?.removeItem(key);
  } catch {
    // Silently fail if storage is not available
  }
};

export const getLocalStorageItem = (key: string): string | null => {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
};

export const setLocalStorageItem = (key: string, value: string): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage?.setItem(key, value);
  } catch {
    // Silently fail if storage is not available
  }
};

export const removeLocalStorageItem = (key: string): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage?.removeItem(key);
  } catch {
    // Silently fail if storage is not available
  }
};
